import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'owl.carousel/dist/owl.carousel.js';
import { ActivatedRoute, Router } from '@angular/router';
import { IAnnouncement } from 'src/modules/shared/interfaces/Iannouncement';
import { INews } from 'src/modules/shared/interfaces/INews';
@Component({
  selector: 'app-what-is-happend',
  templateUrl: './what-is-happend.component.html',
  styleUrls: ['./what-is-happend.component.scss']
})
export class WhatIsHappendComponent implements OnInit {

  newsList: INews[];

  constructor(private activatedRoute: ActivatedRoute) {
    this.newsList = [];
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe( data => {      
        this.newsList = data.news && data.news.Result? data.news.Result:[];
    },error => console.log("Error: ", error));
  }
  
  /*--------------------owl carosel options----------*/
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    margin: 40,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true
      },
      400: {
        items: 2,
        nav: false
      },
      740: {
        items: 3,
        nav: false
      },
      940: {
        items: 3,
        nav: false
      }
    }

  }
}


